import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import PillarPage from "./pages/PillarPage";
import Activities from "./pages/Activities";
import ActivityDetail from "./pages/ActivityDetail";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import Stories from "./pages/Stories";
import StoryDetail from "./pages/StoryDetail";
import Impact from "./pages/Impact";
import GetInvolved from "./pages/GetInvolved";
import Legal from "./pages/Legal";
import NotFound from "./pages/NotFound";

function useLenis() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useLenis();
  return (
    <div className="grain bg-sand text-ink min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/animals" element={<PillarPage key="animals" pillarKey="animals" />} />
          <Route path="/people" element={<PillarPage key="people" pillarKey="people" />} />
          <Route path="/nature" element={<PillarPage key="nature" pillarKey="nature" />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/activities/:slug" element={<ActivityDetail />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:slug" element={<EventDetail />} />
          <Route path="/stories" element={<Stories />} />
          <Route path="/stories/:slug" element={<StoryDetail />} />
          <Route path="/impact" element={<Impact />} />
          <Route path="/get-involved" element={<GetInvolved />} />
          <Route path="/privacy" element={<Legal key="privacy" page="privacy" />} />
          <Route path="/terms" element={<Legal key="terms" page="terms" />} />
          <Route path="/transparency" element={<Legal key="transparency" page="transparency" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
